var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProdTime05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prodTime05",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 74,
    height: 75,
    rx: 6,
    fill: "#53b8ac"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": 5,
    transform: "translate(23 56.5)",
    fill: "#fff",
    fontSize: 50,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdTime05);
export default __webpack_public_path__ + "static/media/prodTime05.eea823f5199f55cdaca74eb94447f80e.svg";
export { ForwardRef as ReactComponent };